/* © EVRY. All rights reserved. This code/information is protected by national and international law and may not be used, copied, amended, compiled, decompiled, transferred etc. without the explicitly written prior consent from EVRY.  Any use in violation of the said will be prosecuted and compensation will be claimed. */
function EVRY_PINCrypto() {

    var storedDesKey = null;
    var storedRsaKeyname = null;

    var bpe, mask, radix, digitsStr, one, t, s0, s3, s4, s5, s6, s7, sa;

    function resetVars() {

        bpe = 0;
        mask = 0;

        radix = mask + 1;

        digitsStr = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_=!@#$%^&*()[]{}|;:,.<>/?`~ \\\'\"+-";

        for (bpe = 0; (1 << (bpe + 1)) > (1 << bpe); bpe++)
            ;
        bpe >>= 1;

        mask = (1 << bpe) - 1;

        radix = mask + 1;

        one = int2bigInt(1, 1, 1);

        t = new Array(0);
        s0 = t;
        s3 = t;
        s4 = t, s5 = t;
        s6 = t;
        s7 = t;
        sa = t;
    }

    function getSingleEntropyCollectedRandom() {
        var d = Date.now();
        var i = 0;
        var x = 0;
        var lastRandom = null;
        do {
            i++;
            x = Math.sin(Math.sqrt(Math.log(i + x)));
            lastRandom = (Math.random() * 0x100000000).toFixed(0) >>> 0;
        } while (Date.now() < d + 2);

        return {
            counter: i,
            randomvalue: lastRandom
        };
    }

    function generateEntropyCollectedRandom(numRounds) {
        var calculatedRandom = 0;
        var collectedData = [];
        for (var i = 0; i < numRounds; i++) {
            var singleEntropyRandom = getSingleEntropyCollectedRandom();
            collectedData.push(singleEntropyRandom);
            calculatedRandom ^= (singleEntropyRandom.randomvalue);
        }

        return calculatedRandom;
    }

    function getRandom(strongRandom) {
        var cryptoLib = null;
        if (typeof window != "undefined")
            cryptoLib = (window.crypto || window.msCrypto);

        if ((cryptoLib != null)
            && (typeof cryptoLib.getRandomValues === "function")) {

            var buf = new Uint32Array(1);
            cryptoLib.getRandomValues(buf);
            return buf[0];
        } else if (strongRandom) {
            return generateEntropyCollectedRandom(16);
        } else {

            return (Math.random() * 0x100000000).toFixed(0) >>> 0;
        }
    }

    function getTLV(id, data) {
        return String.fromCharCode(id) + String.fromCharCode(data.length)
            + data;
    }

    function getBinRandom(num, strongRandom) {
        var totalStr = "";
        var random = 0;
        for (var i = 0; i < num; i++) {
            if (i % 4 == 0) {
                random = getRandom(strongRandom);
            }
            totalStr = String.fromCharCode((random & 0xff)) + totalStr;
            random = random >> 8;
        }
        return totalStr;
    }

    function setCharAt(str, index, chr) {
        if (index > str.length - 1)
            return str;
        return str.substr(0, index) + chr + str.substr(index + 1);
    }

    function getNonZeroByteRandom() {
        var paddingElem = 0;
        while (paddingElem == 0) {
            paddingElem = getRandom() & 0xff;
        }
        return paddingElem;
    }

    function pkcs15Padding(data, length) {
        var paddingElem, i;

        var padding = String.fromCharCode(0, 2);

        var paddingLength = length - data.length - (3 * 2);

        for (i = 0; i < paddingLength - 32; i += 2) {
            paddingElem = getNonZeroByteRandom();
            padding = padding + String.fromCharCode(paddingElem);
        }

        var entropyCollectedPadding = getBinRandom(16, true);
        for (i = 0; i < 16; i++) {
            paddingElem = entropyCollectedPadding.charCodeAt(i);
            if (paddingElem == 0) {
                paddingElem = getNonZeroByteRandom();
                entropyCollectedPadding = setCharAt(entropyCollectedPadding, i,
                    String.fromCharCode(paddingElem));
            }
        }

        padding = padding + entropyCollectedPadding + String.fromCharCode(0);

        var total = asciiToHexString(padding) + data;
        return total;
    }

    function generateDesKey() {

        var key = getBinRandom(16, true);
        return key;
    }

    function getEncryptInputData(rsaModStr, InputDataHex) {
        var rsaExpStr = "010001";

        var rsaExp = str2bigInt(rsaExpStr, 16, 0);
        var rsaMod = str2bigInt(rsaModStr, 16, 0);
        var rsaDat = str2bigInt(InputDataHex, 16, rsaMod.length);

        rsaDat = powMod(rsaDat, rsaExp, rsaMod);

        var EncryptedInputDataHex = bigInt2str(rsaDat, 16);
        while (EncryptedInputDataHex.length < 512)
            EncryptedInputDataHex = "0" + EncryptedInputDataHex;

        return EncryptedInputDataHex;
    }

    function asciiToHexString(str) {
        var hex = "0123456789abcdef";
        var convertedStr = "";
        for (var i = 0; i < str.length; i++) {
            convertedStr += hex.charAt(str.charCodeAt(i) >>> 4);
            convertedStr += hex.charAt(str.charCodeAt(i) & 0xf);
        }

        return convertedStr;
    }

    function toBin(hex) {
        var bytes = [];

        for (var i = 0; i < hex.length - 1; i += 2) {
            bytes.push(parseInt(hex.substr(i, 2), 16));
        }

        return String.fromCharCode.apply(String, bytes);
    }

    function addDesPadding(data) {
        var paddingLength = (8 - data.length % 8);
        for (var i = 0; i < paddingLength; i++) {
            data = data + String.fromCharCode(paddingLength);
        }
        return data;
    }

    function generatePinBlock(PIN) {

        var PINBlock = String.fromCharCode(20);

        for (var i = 0; i < 4; i += 2) {
            var PinDigit1 = parseInt(PIN.substring(i, i + 1));
            var PinDigit2 = parseInt(PIN.substring(i + 1, i + 2));
            PINBlock = PINBlock
                + String.fromCharCode(PinDigit1 * 16 + PinDigit2);
        }

        PINBlock = PINBlock + getBinRandom(5, true);

        return PINBlock;
    }

    function generateMac(fullLengthDesKey, header) {

        var numPaddingBytes = header.length % 8;

        var paddedHeader = header;

        if (numPaddingBytes > 0) {
            numPaddingBytes = 8 - numPaddingBytes;
            var padding = "";
            for (var i = 0; i < numPaddingBytes; i++) {
                padding += String.fromCharCode(0);
            }
            paddedHeader = header + padding;
        }

        var iv = String.fromCharCode(0, 0, 0, 0, 0, 0, 0, 0);

        var desEncryptedHeader = des(fullLengthDesKey, paddedHeader, 1, 1, iv);

        var mac = desEncryptedHeader.substring(desEncryptedHeader.length - 8,
            desEncryptedHeader.length - 4);

        return mac;
    }

    function encryptData(functionName, rsaKeyName, rsaKeyMod, pinBlock, tlvData) {

        var header = functionName + rsaKeyName + ".";

        var desKey = generateDesKey();
        var fullLengthDesKey = desKey + desKey.substring(0, 8);
        var InputDataHex = pkcs15Padding(asciiToHexString(desKey), 512);

        var rsaEncryptedData = getEncryptInputData(rsaKeyMod, InputDataHex);

        var mac = generateMac(fullLengthDesKey, header);

        var randomData = getBinRandom(8, true);
        tlvData = randomData + addDesPadding(tlvData);

        var iv = String.fromCharCode(0, 0, 0, 0, 0, 0, 0, 0);

        var encryptedTLVData = des(fullLengthDesKey, tlvData, 1, 1, iv);

        var encryptedDesData = asciiToHexString(encryptedTLVData);

        var encryptedPIN = "";
        if (pinBlock != null) {
            encryptedPIN = asciiToHexString(des(fullLengthDesKey,
                toBin(pinBlock), 1, 1, iv));
        }

        var encryptedBlob = asciiToHexString(header) + asciiToHexString(mac)
            + rsaEncryptedData + encryptedPIN + encryptedDesData;

        encryptedBlob = encryptedBlob.toLowerCase();

        return {
            encrypedBlob: encryptedBlob,
            desKey: desKey
        };
    }

    return {

        deleteSessionData: function () {
            resetVars();
            storedDesKey = null;
            storedRsaKeyname = null;
        },

        encryptCCPWriteData: function (rsaKeyName, rsaKeyMod, customerNo, pin,
            cardNo, expDate, cvv2) {
            resetVars();
            try {
                var pinBlock = asciiToHexString(generatePinBlock(pin));

                var tlvData = getTLV(1, customerNo);

                if (cardNo != null && cardNo.length != 0) {
                    tlvData = tlvData + getTLV(2, cardNo);
                }
                if (expDate != null && expDate.length != 0) {
                    tlvData = tlvData + getTLV(3, expDate);
                }
                if (cvv2 != null && cvv2.length != 0) {
                    tlvData = tlvData + asciiToHexString(getTLV(4, cvv2));
                }

                var ans = encryptData(".CCP.004.I.", rsaKeyName, rsaKeyMod,
                    pinBlock, tlvData);

                return ans.encrypedBlob;

            } finally {
                resetVars();
            }
        },

        encryptPinReadData: function (rsaKeyName, rsaKeyMod, expDate, cvv2) {
            resetVars();
            try {

                var tlvDataBin = getTLV(3, expDate) + getTLV(4, cvv2);

                var ans = encryptData(".PON.004.I.", rsaKeyName, rsaKeyMod,
                    null, tlvDataBin);
                storedDesKey = ans.desKey;
                storedRsaKeyname = rsaKeyName;

                return ans.encrypedBlob;
            } catch (err) {
                storedDesKey = null;
                storedRsaKeyname = null;
                throw err;
            } finally {
                resetVars();
            }
        },

        getPIN: function (encryptedPinblockHex) {
            resetVars();
            try {
                if (storedDesKey == null) {
                    throw "No session data found";
                }
                encryptedPinblockHex = encryptedPinblockHex.toLowerCase();

                var fullLengthDesKey = storedDesKey
                    + storedDesKey.substring(0, 8);

                var header = ".PON.004.O." + storedRsaKeyname + ".";

                var mac = generateMac(fullLengthDesKey, header);
                var expectedHeaderAndMac = asciiToHexString(header + mac)
                    .toLowerCase();

                if (!encryptedPinblockHex.startsWith(expectedHeaderAndMac)) {
                    throw "Unexpected header value";
                }

                if (encryptedPinblockHex.length - expectedHeaderAndMac.length !== 16) {
                    throw "encryptedPinblockHex is of unexpected length";
                }

                var encryptedPinblock = toBin(encryptedPinblockHex
                    .substring(expectedHeaderAndMac.length));

                var decryptedPINBlock = des(fullLengthDesKey,
                    encryptedPinblock, 0, 0);

                var expanded_encryptedPINBlock = asciiToHexString(decryptedPINBlock);
                if (!expanded_encryptedPINBlock.match(/^14\d{4}/)) {
                    throw "Decrypted PIN block is not in the expected format";
                }

                return expanded_encryptedPINBlock.substring(2, 6);
            } finally {
                storedDesKey = null;
                storedRsaKeyname = null;
                resetVars();
            }
        }
    };

    function expand(x, n) {
        var ans = int2bigInt(0, (x.length > n ? x.length : n) * bpe, 0);
        copy_(ans, x);
        return ans;
    }

    function powMod(x, y, n) {
        var ans = expand(x, n.length);
        powMod_(ans, trim(y, 2), trim(n, 2), 0);

        return trim(ans, 1);
    }

    function inverseModInt(x, n) {
        var a = 1, b = 0;
        for (; ;) {
            if (x == 1)
                return a;
            if (x == 0)
                return 0;
            b -= a * Math.floor(n / x);
            n %= x;

            if (n == 1)
                return b;

            if (n == 0)
                return 0;
            a -= b * Math.floor(x / n);
            x %= n;
        }
    }

    function negative(x) {
        return ((x[x.length - 1] >> (bpe - 1)) & 1);
    }

    function greaterShift(x, y, shift) {
        var i, kx = x.length, ky = y.length;
        var k = ((kx + shift) < ky) ? (kx + shift) : ky;
        for (i = ky - 1 - shift; i < kx && i >= 0; i++)
            if (x[i] > 0)
                return 1;

        for (i = kx - 1 + shift; i < ky; i++)
            if (y[i] > 0)
                return 0;

        for (i = k - 1; i >= shift; i--)
            if (x[i - shift] > y[i])
                return 1;
            else if (x[i - shift] < y[i])
                return 0;
        return 0;
    }

    function greater(x, y) {
        var i;
        var k = (x.length < y.length) ? x.length : y.length;

        for (i = x.length; i < y.length; i++)
            if (y[i])
                return 0;

        for (i = y.length; i < x.length; i++)
            if (x[i])
                return 1;

        for (i = k - 1; i >= 0; i--)
            if (x[i] > y[i])
                return 1;
            else if (x[i] < y[i])
                return 0;
        return 0;
    }

    function divide_(x, y, q, r) {
        var kx, ky;
        var i, y1, y2, c, a, b;
        copy_(r, x);
        for (ky = y.length; y[ky - 1] == 0; ky--)
            ;

        b = y[ky - 1];
        for (a = 0; b; a++)
            b >>= 1;
        a = bpe - a;

        leftShift_(y, a);

        leftShift_(r, a);

        for (kx = r.length; r[kx - 1] == 0 && kx > ky; kx--)
            ;

        copyInt_(q, 0);
        while (!greaterShift(y, r, kx - ky)) {

            subShift_(r, y, kx - ky);
            q[kx - ky]++;
        }

        for (i = kx - 1; i >= ky; i--) {
            if (r[i] == y[ky - 1])
                q[i - ky] = mask;
            else
                q[i - ky] = Math.floor((r[i] * radix + r[i - 1]) / y[ky - 1]);

            for (; ;) {
                y2 = (ky > 1 ? y[ky - 2] : 0) * q[i - ky];
                c = y2 >> bpe;
                y2 = y2 & mask;
                y1 = c + q[i - ky] * y[ky - 1];
                c = y1 >> bpe;
                y1 = y1 & mask;

                if (c == r[i] ? y1 == r[i - 1] ? y2 > (i > 1 ? r[i - 2] : 0)
                    : y1 > r[i - 1] : c > r[i])
                    q[i - ky]--;
                else
                    break;
            }

            linCombShift_(r, y, -q[i - ky], i - ky);
            if (negative(r)) {
                addShift_(r, y, i - ky);
                q[i - ky]--;
            }
        }

        rightShift_(y, a);
        rightShift_(r, a);
    }

    function modInt(x, n) {
        var i, c = 0;
        for (i = x.length - 1; i >= 0; i--)
            c = (c * radix + x[i]) % n;
        return c;
    }

    function int2bigInt(t, bits, minSize) {
        var k;
        k = Math.ceil(bits / bpe) + 1;
        k = minSize > k ? minSize : k;
        var buff = new Array(k);
        copyInt_(buff, t);
        return buff;
    }

    function str2bigInt(s, b, minSize) {
        var d, i, base, str, x, y, kk;
        if (typeof b === "string") {
            base = b.length;
            str = b;
        } else {
            base = b;
            str = digitsStr;
        }
        var k = s.length;
        if (base == -1) {
            x = new Array(0);
            for (; ;) {
                y = new Array(x.length + 1);
                for (i = 0; i < x.length; i++)
                    y[i + 1] = x[i];
                y[0] = parseInt(s, 10);
                x = y;
                d = s.indexOf(",", 0);
                if (d < 1)
                    break;
                s = s.substring(d + 1);
                if (s.length == 0)
                    break;
            }
            if (x.length < minSize) {
                y = new Array(minSize);
                copy_(y, x);
                return y;
            }
            return x;
        }

        x = int2bigInt(0, base * k, 0);
        for (i = 0; i < k; i++) {
            d = str.indexOf(s.substring(i, i + 1), 0);
            if (base <= 36 && d >= 36) {

                d -= 26;
            }
            if (d >= base || d < 0) {
                continue;
            }
            multInt_(x, base);
            addInt_(x, d);
        }

        for (k = x.length; k > 0 && !x[k - 1]; k--)
            ;
        k = minSize > k + 1 ? minSize : k + 1;
        y = new Array(k);
        kk = k < x.length ? k : x.length;
        for (i = 0; i < kk; i++)
            y[i] = x[i];
        for (; i < k; i++)
            y[i] = 0;
        return y;
    }

    function equalsInt(x, y) {
        var i;
        if (x[0] != y)
            return 0;
        for (i = 1; i < x.length; i++)
            if (x[i])
                return 0;
        return 1;
    }

    function isZero(x) {
        var i;
        for (i = 0; i < x.length; i++)
            if (x[i])
                return 0;
        return 1;
    }

    function bigInt2str(x, b) {
        var i, t, base, str, s = "";
        if (typeof b === "string") {
            base = b.length;
            str = b;
        } else {
            base = b;
            str = digitsStr;
        }

        if (s6.length != x.length)
            s6 = dup(x);
        else
            copy_(s6, x);

        if (base == -1) {
            for (i = x.length - 1; i > 0; i--)
                s += x[i] + ",";
            s += x[0];
        } else {
            while (!isZero(s6)) {
                t = divInt_(s6, base);
                s = str.substring(t, t + 1) + s;
            }
        }
        if (s.length == 0)
            s = str[0];
        return s;
    }

    function dup(x) {
        var buff = new Array(x.length);
        copy_(buff, x);
        return buff;
    }

    function copy_(x, y) {
        var i;
        var k = x.length < y.length ? x.length : y.length;
        for (i = 0; i < k; i++)
            x[i] = y[i];
        for (i = k; i < x.length; i++)
            x[i] = 0;
    }

    function copyInt_(x, n) {
        var i, c;
        for (c = n, i = 0; i < x.length; i++) {
            x[i] = c & mask;
            c >>= bpe;
        }
    }

    function addInt_(x, n) {
        var i, k, c, b;
        x[0] += n;
        k = x.length;
        c = 0;
        for (i = 0; i < k; i++) {
            c += x[i];
            b = 0;
            if (c < 0) {
                b = -(c >> bpe);
                c += b * radix;
            }
            x[i] = c & mask;
            c = (c >> bpe) - b;
            if (!c)
                return;
        }
    }

    function rightShift_(x, n) {
        var i;
        var k = Math.floor(n / bpe);
        if (k) {
            for (i = 0; i < x.length - k; i++)

                x[i] = x[i + k];
            for (; i < x.length; i++)
                x[i] = 0;
            n %= bpe;
        }
        for (i = 0; i < x.length - 1; i++) {
            x[i] = mask & ((x[i + 1] << (bpe - n)) | (x[i] >> n));
        }
        x[i] >>= n;
    }

    function leftShift_(x, n) {
        var i;
        var k = Math.floor(n / bpe);
        if (k) {
            for (i = x.length; i >= k; i--)

                x[i] = x[i - k];
            for (; i >= 0; i--)
                x[i] = 0;
            n %= bpe;
        }
        if (!n)
            return;
        for (i = x.length - 1; i > 0; i--) {
            x[i] = mask & ((x[i] << n) | (x[i - 1] >> (bpe - n)));
        }
        x[i] = mask & (x[i] << n);
    }

    function multInt_(x, n) {
        var i, k, c, b;
        if (!n)
            return;
        k = x.length;
        c = 0;
        for (i = 0; i < k; i++) {
            c += x[i] * n;
            b = 0;
            if (c < 0) {
                b = -(c >> bpe);
                c += b * radix;
            }
            x[i] = c & mask;
            c = (c >> bpe) - b;
        }
    }

    function divInt_(x, n) {
        var i, r = 0, s;
        for (i = x.length - 1; i >= 0; i--) {
            s = r * radix + x[i];
            x[i] = Math.floor(s / n);
            r = s % n;
        }
        return r;
    }

    function linCombShift_(x, y, b, ys) {
        var i, c, k, kk;
        k = x.length < ys + y.length ? x.length : ys + y.length;
        kk = x.length;
        for (c = 0, i = ys; i < k; i++) {
            c += x[i] + b * y[i - ys];
            x[i] = c & mask;
            c >>= bpe;
        }
        for (i = k; c && i < kk; i++) {
            c += x[i];
            x[i] = c & mask;
            c >>= bpe;
        }
    }

    function addShift_(x, y, ys) {
        var i, c, k, kk;
        k = x.length < ys + y.length ? x.length : ys + y.length;
        kk = x.length;
        for (c = 0, i = ys; i < k; i++) {
            c += x[i] + y[i - ys];
            x[i] = c & mask;
            c >>= bpe;
        }
        for (i = k; c && i < kk; i++) {
            c += x[i];
            x[i] = c & mask;
            c >>= bpe;
        }
    }

    function subShift_(x, y, ys) {
        var i, c, k, kk;
        k = x.length < ys + y.length ? x.length : ys + y.length;
        kk = x.length;
        for (c = 0, i = ys; i < k; i++) {
            c += x[i] - y[i - ys];
            x[i] = c & mask;
            c >>= bpe;
        }
        for (i = k; c && i < kk; i++) {
            c += x[i];
            x[i] = c & mask;
            c >>= bpe;
        }
    }

    function sub_(x, y) {
        var i, c, k;
        k = x.length < y.length ? x.length : y.length;
        for (c = 0, i = 0; i < k; i++) {
            c += x[i] - y[i];
            x[i] = c & mask;
            c >>= bpe;
        }
        for (i = k; c && i < x.length; i++) {
            c += x[i];
            x[i] = c & mask;
            c >>= bpe;
        }
    }

    function mod_(x, n) {
        if (s4.length != x.length)
            s4 = dup(x);
        else
            copy_(s4, x);
        if (s5.length != x.length)
            s5 = dup(x);
        divide_(s4, n, s5, x);
    }

    function multMod_(x, y, n) {
        var i;
        if (s0.length != 2 * x.length)
            s0 = new Array(2 * x.length);
        copyInt_(s0, 0);
        for (i = 0; i < y.length; i++)
            if (y[i])
                linCombShift_(s0, x, y[i], i);
        mod_(s0, n);
        copy_(x, s0);
    }

    function squareMod_(x, n) {
        var i, j, c, kx, k;
        for (kx = x.length; kx > 0 && !x[kx - 1]; kx--)
            ;
        k = kx > n.length ? 2 * kx : 2 * n.length;

        if (s0.length != k)
            s0 = new Array(k);
        copyInt_(s0, 0);
        for (i = 0; i < kx; i++) {
            c = s0[2 * i] + x[i] * x[i];
            s0[2 * i] = c & mask;
            c >>= bpe;
            for (j = i + 1; j < kx; j++) {
                c = s0[i + j] + 2 * x[i] * x[j] + c;
                s0[i + j] = (c & mask);
                c >>= bpe;
            }
            s0[i + kx] = c;
        }
        mod_(s0, n);
        copy_(x, s0);
    }

    function trim(x, k) {
        var i, y;
        for (i = x.length; i > 0 && !x[i - 1]; i--)
            ;
        y = new Array(i + k);
        copy_(y, x);
        return y;
    }

    function powMod_(x, y, n) {
        var k1, k2, kn, np;
        if (s7.length != n.length)
            s7 = dup(n);

        if ((n[0] & 1) == 0) {
            copy_(s7, x);
            copyInt_(x, 1);
            while (!equalsInt(y, 0)) {
                if (y[0] & 1)
                    multMod_(x, s7, n);
                divInt_(y, 2);
                squareMod_(s7, n);
            }
            return;
        }

        copyInt_(s7, 0);
        for (kn = n.length; kn > 0 && !n[kn - 1]; kn--)
            ;
        np = radix - inverseModInt(modInt(n, radix), radix);
        s7[kn] = 1;
        multMod_(x, s7, n);

        if (s3.length != x.length)
            s3 = dup(x);
        else
            copy_(s3, x);

        for (k1 = y.length - 1; k1 > 0 & !y[k1]; k1--)
            ;
        if (y[k1] == 0) {
            copyInt_(x, 1);
            return;
        }
        for (k2 = 1 << (bpe - 1); k2 && !(y[k1] & k2); k2 >>= 1)
            ;
        for (; ;) {
            if (!(k2 >>= 1)) {
                k1--;
                if (k1 < 0) {
                    mont_(x, one, n, np);
                    return;
                }
                k2 = 1 << (bpe - 1);
            }
            mont_(x, x, n, np);

            if (k2 & y[k1])
                mont_(x, s3, n, np);
        }
    }

    function mont_(x, y, n, np) {
        var i, j, c, ui, t, ks;
        var kn = n.length;
        var ky = y.length;

        if (sa.length != kn)
            sa = new Array(kn);

        copyInt_(sa, 0);

        for (; kn > 0 && n[kn - 1] == 0; kn--)
            ;
        for (; ky > 0 && y[ky - 1] == 0; ky--)
            ;
        ks = sa.length - 1;

        for (i = 0; i < kn; i++) {
            t = sa[0] + x[i] * y[0];
            ui = ((t & mask) * np) & mask;

            c = (t + ui * n[0]) >> bpe;
            t = x[i];

            j = 1;
            for (; j < ky - 4;) {
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
            }
            for (; j < ky;) {
                c += sa[j] + ui * n[j] + t * y[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
            }
            for (; j < kn - 4;) {
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
            }
            for (; j < kn;) {
                c += sa[j] + ui * n[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
            }
            for (; j < ks;) {
                c += sa[j];
                sa[j - 1] = c & mask;
                c >>= bpe;
                j++;
            }
            sa[j - 1] = c & mask;
        }

        if (!greater(n, sa))
            sub_(sa, n);
        copy_(x, sa);
    }

    function des(key, message, encrypt, mode, iv) {

        var spfunction1 = new Array(0x1010400, 0, 0x10000, 0x1010404,
            0x1010004, 0x10404, 0x4, 0x10000, 0x400, 0x1010400, 0x1010404,
            0x400, 0x1000404, 0x1010004, 0x1000000, 0x4, 0x404, 0x1000400,
            0x1000400, 0x10400, 0x10400, 0x1010000, 0x1010000, 0x1000404,
            0x10004, 0x1000004, 0x1000004, 0x10004, 0, 0x404, 0x10404,
            0x1000000, 0x10000, 0x1010404, 0x4, 0x1010000, 0x1010400,
            0x1000000, 0x1000000, 0x400, 0x1010004, 0x10000, 0x10400,
            0x1000004, 0x400, 0x4, 0x1000404, 0x10404, 0x1010404, 0x10004,
            0x1010000, 0x1000404, 0x1000004, 0x404, 0x10404, 0x1010400,
            0x404, 0x1000400, 0x1000400, 0, 0x10004, 0x10400, 0, 0x1010004);
        var spfunction2 = new Array(-0x7fef7fe0, -0x7fff8000, 0x8000, 0x108020,
            0x100000, 0x20, -0x7fefffe0, -0x7fff7fe0, -0x7fffffe0,
            -0x7fef7fe0, -0x7fef8000, -0x80000000, -0x7fff8000, 0x100000,
            0x20, -0x7fefffe0, 0x108000, 0x100020, -0x7fff7fe0, 0,
            -0x80000000, 0x8000, 0x108020, -0x7ff00000, 0x100020,
            -0x7fffffe0, 0, 0x108000, 0x8020, -0x7fef8000, -0x7ff00000,
            0x8020, 0, 0x108020, -0x7fefffe0, 0x100000, -0x7fff7fe0,
            -0x7ff00000, -0x7fef8000, 0x8000, -0x7ff00000, -0x7fff8000,
            0x20, -0x7fef7fe0, 0x108020, 0x20, 0x8000, -0x80000000, 0x8020,
            -0x7fef8000, 0x100000, -0x7fffffe0, 0x100020, -0x7fff7fe0,
            -0x7fffffe0, 0x100020, 0x108000, 0, -0x7fff8000, 0x8020,
            -0x80000000, -0x7fefffe0, -0x7fef7fe0, 0x108000);
        var spfunction3 = new Array(0x208, 0x8020200, 0, 0x8020008, 0x8000200,
            0, 0x20208, 0x8000200, 0x20008, 0x8000008, 0x8000008, 0x20000,
            0x8020208, 0x20008, 0x8020000, 0x208, 0x8000000, 0x8,
            0x8020200, 0x200, 0x20200, 0x8020000, 0x8020008, 0x20208,
            0x8000208, 0x20200, 0x20000, 0x8000208, 0x8, 0x8020208, 0x200,
            0x8000000, 0x8020200, 0x8000000, 0x20008, 0x208, 0x20000,
            0x8020200, 0x8000200, 0, 0x200, 0x20008, 0x8020208, 0x8000200,
            0x8000008, 0x200, 0, 0x8020008, 0x8000208, 0x20000, 0x8000000,
            0x8020208, 0x8, 0x20208, 0x20200, 0x8000008, 0x8020000,
            0x8000208, 0x208, 0x8020000, 0x20208, 0x8, 0x8020008, 0x20200);
        var spfunction4 = new Array(0x802001, 0x2081, 0x2081, 0x80, 0x802080,
            0x800081, 0x800001, 0x2001, 0, 0x802000, 0x802000, 0x802081,
            0x81, 0, 0x800080, 0x800001, 0x1, 0x2000, 0x800000, 0x802001,
            0x80, 0x800000, 0x2001, 0x2080, 0x800081, 0x1, 0x2080,
            0x800080, 0x2000, 0x802080, 0x802081, 0x81, 0x800080, 0x800001,
            0x802000, 0x802081, 0x81, 0, 0, 0x802000, 0x2080, 0x800080,
            0x800081, 0x1, 0x802001, 0x2081, 0x2081, 0x80, 0x802081, 0x81,
            0x1, 0x2000, 0x800001, 0x2001, 0x802080, 0x800081, 0x2001,
            0x2080, 0x800000, 0x802001, 0x80, 0x800000, 0x2000, 0x802080);
        var spfunction5 = new Array(0x100, 0x2080100, 0x2080000, 0x42000100,
            0x80000, 0x100, 0x40000000, 0x2080000, 0x40080100, 0x80000,
            0x2000100, 0x40080100, 0x42000100, 0x42080000, 0x80100,
            0x40000000, 0x2000000, 0x40080000, 0x40080000, 0, 0x40000100,
            0x42080100, 0x42080100, 0x2000100, 0x42080000, 0x40000100, 0,
            0x42000000, 0x2080100, 0x2000000, 0x42000000, 0x80100, 0x80000,
            0x42000100, 0x100, 0x2000000, 0x40000000, 0x2080000,
            0x42000100, 0x40080100, 0x2000100, 0x40000000, 0x42080000,
            0x2080100, 0x40080100, 0x100, 0x2000000, 0x42080000,
            0x42080100, 0x80100, 0x42000000, 0x42080100, 0x2080000, 0,
            0x40080000, 0x42000000, 0x80100, 0x2000100, 0x40000100,
            0x80000, 0, 0x40080000, 0x2080100, 0x40000100);
        var spfunction6 = new Array(0x20000010, 0x20400000, 0x4000, 0x20404010,
            0x20400000, 0x10, 0x20404010, 0x400000, 0x20004000, 0x404010,
            0x400000, 0x20000010, 0x400010, 0x20004000, 0x20000000, 0x4010,
            0, 0x400010, 0x20004010, 0x4000, 0x404000, 0x20004010, 0x10,
            0x20400010, 0x20400010, 0, 0x404010, 0x20404000, 0x4010,
            0x404000, 0x20404000, 0x20000000, 0x20004000, 0x10, 0x20400010,
            0x404000, 0x20404010, 0x400000, 0x4010, 0x20000010, 0x400000,
            0x20004000, 0x20000000, 0x4010, 0x20000010, 0x20404010,
            0x404000, 0x20400000, 0x404010, 0x20404000, 0, 0x20400010,
            0x10, 0x4000, 0x20400000, 0x404010, 0x4000, 0x400010,
            0x20004010, 0, 0x20404000, 0x20000000, 0x400010, 0x20004010);
        var spfunction7 = new Array(0x200000, 0x4200002, 0x4000802, 0, 0x800,
            0x4000802, 0x200802, 0x4200800, 0x4200802, 0x200000, 0,
            0x4000002, 0x2, 0x4000000, 0x4200002, 0x802, 0x4000800,
            0x200802, 0x200002, 0x4000800, 0x4000002, 0x4200000, 0x4200800,
            0x200002, 0x4200000, 0x800, 0x802, 0x4200802, 0x200800, 0x2,
            0x4000000, 0x200800, 0x4000000, 0x200800, 0x200000, 0x4000802,
            0x4000802, 0x4200002, 0x4200002, 0x2, 0x200002, 0x4000000,
            0x4000800, 0x200000, 0x4200800, 0x802, 0x200802, 0x4200800,
            0x802, 0x4000002, 0x4200802, 0x4200000, 0x200800, 0, 0x2,
            0x4200802, 0, 0x200802, 0x4200000, 0x800, 0x4000002, 0x4000800,
            0x800, 0x200002);
        var spfunction8 = new Array(0x10001040, 0x1000, 0x40000, 0x10041040,
            0x10000000, 0x10001040, 0x40, 0x10000000, 0x40040, 0x10040000,
            0x10041040, 0x41000, 0x10041000, 0x41040, 0x1000, 0x40,
            0x10040000, 0x10000040, 0x10001000, 0x1040, 0x41000, 0x40040,
            0x10040040, 0x10041000, 0x1040, 0, 0, 0x10040040, 0x10000040,
            0x10001000, 0x41040, 0x40000, 0x41040, 0x40000, 0x10041000,
            0x1000, 0x40, 0x10040040, 0x1000, 0x41040, 0x10001000, 0x40,
            0x10000040, 0x10040000, 0x10040040, 0x10000000, 0x40000,
            0x10001040, 0, 0x10041040, 0x40040, 0x10000040, 0x10040000,
            0x10001000, 0x10001040, 0, 0x10041040, 0x41000, 0x41000,
            0x1040, 0x1040, 0x40040, 0x10000000, 0x10041000);

        var keys = des_createKeys(key);
        var m = 0, i, j, temp, right1, right2, left, right, looping;
        var cbcleft, cbcleft2, cbcright, cbcright2;
        var endloop, loopinc;
        var len = message.length;
        var chunk = 0;

        var iterations = keys.length == 32 ? 3 : 9;
        if (iterations == 3) {
            looping = encrypt ? new Array(0, 32, 2) : new Array(30, -2, -2);
        } else {
            looping = encrypt ? new Array(0, 32, 2, 62, 30, -2, 64, 96, 2)
                : new Array(94, 62, -2, 32, 64, 2, 30, -2, -2);
        }

        message += "\0\0\0\0\0\0\0\0";

        var result = "";
        var tempresult = "";

        if (mode == 1) {
            cbcleft = (iv.charCodeAt(m++) << 24) | (iv.charCodeAt(m++) << 16)
                | (iv.charCodeAt(m++) << 8) | iv.charCodeAt(m++);
            cbcright = (iv.charCodeAt(m++) << 24) | (iv.charCodeAt(m++) << 16)
                | (iv.charCodeAt(m++) << 8) | iv.charCodeAt(m++);
            m = 0;
        }

        while (m < len) {
            left = (message.charCodeAt(m++) << 24)
                | (message.charCodeAt(m++) << 16)
                | (message.charCodeAt(m++) << 8) | message.charCodeAt(m++);
            right = (message.charCodeAt(m++) << 24)
                | (message.charCodeAt(m++) << 16)
                | (message.charCodeAt(m++) << 8) | message.charCodeAt(m++);

            if (mode == 1) {
                if (encrypt) {
                    left ^= cbcleft;
                    right ^= cbcright;
                } else {
                    cbcleft2 = cbcleft;
                    cbcright2 = cbcright;
                    cbcleft = left;
                    cbcright = right;
                }
            }

            temp = ((left >>> 4) ^ right) & 0x0f0f0f0f;
            right ^= temp;
            left ^= (temp << 4);
            temp = ((left >>> 16) ^ right) & 0x0000ffff;
            right ^= temp;
            left ^= (temp << 16);
            temp = ((right >>> 2) ^ left) & 0x33333333;
            left ^= temp;
            right ^= (temp << 2);
            temp = ((right >>> 8) ^ left) & 0x00ff00ff;
            left ^= temp;
            right ^= (temp << 8);
            temp = ((left >>> 1) ^ right) & 0x55555555;
            right ^= temp;
            left ^= (temp << 1);

            left = ((left << 1) | (left >>> 31));
            right = ((right << 1) | (right >>> 31));

            for (j = 0; j < iterations; j += 3) {
                endloop = looping[j + 1];
                loopinc = looping[j + 2];

                for (i = looping[j]; i != endloop; i += loopinc) {

                    right1 = right ^ keys[i];
                    right2 = ((right >>> 4) | (right << 28)) ^ keys[i + 1];

                    temp = left;
                    left = right;
                    right = temp
                        ^ (spfunction2[(right1 >>> 24) & 0x3f]
                            | spfunction4[(right1 >>> 16) & 0x3f]
                            | spfunction6[(right1 >>> 8) & 0x3f]
                            | spfunction8[right1 & 0x3f]
                            | spfunction1[(right2 >>> 24) & 0x3f]
                            | spfunction3[(right2 >>> 16) & 0x3f]
                            | spfunction5[(right2 >>> 8) & 0x3f] | spfunction7[right2 & 0x3f]);
                }
                temp = left;
                left = right;
                right = temp;
            }

            left = ((left >>> 1) | (left << 31));
            right = ((right >>> 1) | (right << 31));

            temp = ((left >>> 1) ^ right) & 0x55555555;
            right ^= temp;
            left ^= (temp << 1);
            temp = ((right >>> 8) ^ left) & 0x00ff00ff;
            left ^= temp;
            right ^= (temp << 8);
            temp = ((right >>> 2) ^ left) & 0x33333333;
            left ^= temp;
            right ^= (temp << 2);
            temp = ((left >>> 16) ^ right) & 0x0000ffff;
            right ^= temp;
            left ^= (temp << 16);
            temp = ((left >>> 4) ^ right) & 0x0f0f0f0f;
            right ^= temp;
            left ^= (temp << 4);

            if (mode == 1) {
                if (encrypt) {
                    cbcleft = left;
                    cbcright = right;
                } else {
                    left ^= cbcleft2;
                    right ^= cbcright2;
                }
            }
            tempresult += String.fromCharCode((left >>> 24),
                ((left >>> 16) & 0xff), ((left >>> 8) & 0xff),
                (left & 0xff), (right >>> 24), ((right >>> 16) & 0xff),
                ((right >>> 8) & 0xff), (right & 0xff));

            chunk += 8;
            if (chunk == 512) {
                result += tempresult;
                tempresult = "";
                chunk = 0;
            }
        }

        return result + tempresult;
    }

    function des_createKeys(key) {

        var pc2bytes0 = new Array(0, 0x4, 0x20000000, 0x20000004, 0x10000,
            0x10004, 0x20010000, 0x20010004, 0x200, 0x204, 0x20000200,
            0x20000204, 0x10200, 0x10204, 0x20010200, 0x20010204);
        var pc2bytes1 = new Array(0, 0x1, 0x100000, 0x100001, 0x4000000,
            0x4000001, 0x4100000, 0x4100001, 0x100, 0x101, 0x100100,
            0x100101, 0x4000100, 0x4000101, 0x4100100, 0x4100101);
        var pc2bytes2 = new Array(0, 0x8, 0x800, 0x808, 0x1000000, 0x1000008,
            0x1000800, 0x1000808, 0, 0x8, 0x800, 0x808, 0x1000000,
            0x1000008, 0x1000800, 0x1000808);
        var pc2bytes3 = new Array(0, 0x200000, 0x8000000, 0x8200000, 0x2000,
            0x202000, 0x8002000, 0x8202000, 0x20000, 0x220000, 0x8020000,
            0x8220000, 0x22000, 0x222000, 0x8022000, 0x8222000);
        var pc2bytes4 = new Array(0, 0x40000, 0x10, 0x40010, 0, 0x40000, 0x10,
            0x40010, 0x1000, 0x41000, 0x1010, 0x41010, 0x1000, 0x41000,
            0x1010, 0x41010);
        var pc2bytes5 = new Array(0, 0x400, 0x20, 0x420, 0, 0x400, 0x20, 0x420,
            0x2000000, 0x2000400, 0x2000020, 0x2000420, 0x2000000,
            0x2000400, 0x2000020, 0x2000420);
        var pc2bytes6 = new Array(0, 0x10000000, 0x80000, 0x10080000, 0x2,
            0x10000002, 0x80002, 0x10080002, 0, 0x10000000, 0x80000,
            0x10080000, 0x2, 0x10000002, 0x80002, 0x10080002);
        var pc2bytes7 = new Array(0, 0x10000, 0x800, 0x10800, 0x20000000,
            0x20010000, 0x20000800, 0x20010800, 0x20000, 0x30000, 0x20800,
            0x30800, 0x20020000, 0x20030000, 0x20020800, 0x20030800);
        var pc2bytes8 = new Array(0, 0x40000, 0, 0x40000, 0x2, 0x40002, 0x2,
            0x40002, 0x2000000, 0x2040000, 0x2000000, 0x2040000, 0x2000002,
            0x2040002, 0x2000002, 0x2040002);
        var pc2bytes9 = new Array(0, 0x10000000, 0x8, 0x10000008, 0,
            0x10000000, 0x8, 0x10000008, 0x400, 0x10000400, 0x408,
            0x10000408, 0x400, 0x10000400, 0x408, 0x10000408);
        var pc2bytes10 = new Array(0, 0x20, 0, 0x20, 0x100000, 0x100020,
            0x100000, 0x100020, 0x2000, 0x2020, 0x2000, 0x2020, 0x102000,
            0x102020, 0x102000, 0x102020);
        var pc2bytes11 = new Array(0, 0x1000000, 0x200, 0x1000200, 0x200000,
            0x1200000, 0x200200, 0x1200200, 0x4000000, 0x5000000,
            0x4000200, 0x5000200, 0x4200000, 0x5200000, 0x4200200,
            0x5200200);
        var pc2bytes12 = new Array(0, 0x1000, 0x8000000, 0x8001000, 0x80000,
            0x81000, 0x8080000, 0x8081000, 0x10, 0x1010, 0x8000010,
            0x8001010, 0x80010, 0x81010, 0x8080010, 0x8081010);
        var pc2bytes13 = new Array(0, 0x4, 0x100, 0x104, 0, 0x4, 0x100, 0x104,
            0x1, 0x5, 0x101, 0x105, 0x1, 0x5, 0x101, 0x105);

        var iterations = key.length >= 24 ? 3 : 1;

        var keys = new Array(32 * iterations);

        var shifts = new Array(0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0);

        var lefttemp, righttemp, m = 0, n = 0, temp;

        for (var j = 0; j < iterations; j++) {
            var left = (key.charCodeAt(m++) << 24)
                | (key.charCodeAt(m++) << 16) | (key.charCodeAt(m++) << 8)
                | key.charCodeAt(m++);
            var right = (key.charCodeAt(m++) << 24)
                | (key.charCodeAt(m++) << 16) | (key.charCodeAt(m++) << 8)
                | key.charCodeAt(m++);

            temp = ((left >>> 4) ^ right) & 0x0f0f0f0f;
            right ^= temp;
            left ^= (temp << 4);
            temp = ((right >>> -16) ^ left) & 0x0000ffff;
            left ^= temp;
            right ^= (temp << -16);
            temp = ((left >>> 2) ^ right) & 0x33333333;
            right ^= temp;
            left ^= (temp << 2);
            temp = ((right >>> -16) ^ left) & 0x0000ffff;
            left ^= temp;
            right ^= (temp << -16);
            temp = ((left >>> 1) ^ right) & 0x55555555;
            right ^= temp;
            left ^= (temp << 1);
            temp = ((right >>> 8) ^ left) & 0x00ff00ff;
            left ^= temp;
            right ^= (temp << 8);
            temp = ((left >>> 1) ^ right) & 0x55555555;
            right ^= temp;
            left ^= (temp << 1);

            temp = (left << 8) | ((right >>> 20) & 0x000000f0);

            left = (right << 24) | ((right << 8) & 0xff0000)
                | ((right >>> 8) & 0xff00) | ((right >>> 24) & 0xf0);
            right = temp;

            for (var i = 0; i < shifts.length; i++) {

                if (shifts[i]) {
                    left = (left << 2) | (left >>> 26);
                    right = (right << 2) | (right >>> 26);
                } else {
                    left = (left << 1) | (left >>> 27);
                    right = (right << 1) | (right >>> 27);
                }
                left &= -0xf;
                right &= -0xf;

                lefttemp = pc2bytes0[left >>> 28]
                    | pc2bytes1[(left >>> 24) & 0xf]
                    | pc2bytes2[(left >>> 20) & 0xf]
                    | pc2bytes3[(left >>> 16) & 0xf]
                    | pc2bytes4[(left >>> 12) & 0xf]
                    | pc2bytes5[(left >>> 8) & 0xf]
                    | pc2bytes6[(left >>> 4) & 0xf];
                righttemp = pc2bytes7[right >>> 28]
                    | pc2bytes8[(right >>> 24) & 0xf]
                    | pc2bytes9[(right >>> 20) & 0xf]
                    | pc2bytes10[(right >>> 16) & 0xf]
                    | pc2bytes11[(right >>> 12) & 0xf]
                    | pc2bytes12[(right >>> 8) & 0xf]
                    | pc2bytes13[(right >>> 4) & 0xf];
                temp = ((righttemp >>> 16) ^ lefttemp) & 0x0000ffff;
                keys[n++] = lefttemp ^ temp;
                keys[n++] = righttemp ^ (temp << 16);
            }
        }

        return keys;
    }

}
